export const mostCommonWords = [
  "",
  " ",
  "be",
  "is",
  "and",
  "of",
  "a",
  "am",
  "in",
  "to",
  "have",
  "too",
  "it",
  "i",
  "that",
  "for",
  "you",
  "he",
  "with",
  "on",
  "do",
  "say",
  "this",
  "they",
  "at",
  "but",
  "we",
  "his",
  "from",
  "that",
  "not",
  "cant",
  "wont",
  "by",
  "she",
  "or",
  "as",
  "what",
  "go",
  "their",
  "can",
  "who",
  "get",
  "if",
  "would",
  "her",
  "all",
  "my",
  "make",
  "about",
  "know",
  "will",
  "as",
  "up",
  "one",
  "time",
  "there",
  "year",
  "so",
  "think",
  "when",
  "which",
  "them",
  "some",
  "me",
  "people",
  "take",
  "out",
  "into",
  "just",
  "see",
  "him",
  "your",
  "come",
  "could",
  "now",
  "than",
  "like",
  "other",
  "how",
  "then",
  "its",
  "our",
  "two",
  "more",
  "these",
  "want",
  "way",
  "look",
  "first",
  "also",
  "new",
  "because",
  "day",
  "more",
  "use",
  "no",
  "man",
  "find",
  "here",
  "thing",
  "give",
  "many",
  "well",
  "only",
  "those",
  "tell",
  "one",
  "very",
  "her",
  "even",
  "back",
  "any",
  "good",
  "through",
  "us",
  "life",
  "child",
  "there",
  "work",
  "down",
  "may",
  "after",
  "should",
  "call",
  "world",
  "over",
  "still",
  "try",
  "in",
  "as",
  "last",
  "ask",
  "need",
  "too",
  "feel",
  "three",
  "when",
  "state",
  "never",
  "become",
  "between",
  "high",
  "really",
  "something",
  "most",
  "another",
  "much",
  "own",
  "out",
  "leave",
  "put",
  "old",
  "while",
  "mean",
  "on",
  "keep",
  "why",
  "let",
  "great",
  "same",
  "big",
  "group",
  "begin",
  "seem",
  "help",
  "talk",
  "where",
  "turn",
  "problem",
  "every",
  "start",
  "hand",
  "might",
  "show",
  "part",
  "about",
  "against",
  "place",
  "over",
  "such",
  "again",
  "few",
  "case",
  "most",
  "week",
  "company",
  "where",
  "system",
  "each",
  "right",
  "program",
  "hear",
  "so",
  "question",
  "during",
  "work",
  "play",
  "government",
  "run",
  "small",
  "number",
  "off",
  "always",
  "move",
  "like",
  "night",
  "live",
  "Mr.",
  "point",
  "believe",
  "hold",
  "today",
  "bring",
  "happen",
  "next",
  "without",
  "before",
  "large",
  "all",
  "must",
  "home",
  "under",
  "room",
  "write",
  "area",
  "story",
  "young",
  "fact",
  "month",
  "different",
  "lot",
  "right",
  "study",
  "book",
  "eye",
  "job",
  "word",
  "though",
  "business",
  "issue",
  "side",
  "kind",
  "four",
  "head",
  "far",
  "both",
  "yes",
  "after",
  "since",
  "long",
  "provide",
  "service",
  "around",
  "friend",
  "important",
  "sit",
  "away",
  "until",
  "power",
  "hour",
  "game",
  "often",
  "yet",
  "line",
];

export const examples = [
  {
    header: "Mystery",
    text: "Write a story where a detective named LaBlanche comes home late at night and finds her husband dead in their study, but there are no visible wounds. When she calls the police, they bring her in for questioning.",
    output: `LaBlanche, an intrepid detective with an eagle eye for detail, returned to her home on the outskirts of town late one night. She had been out on a case all day, and all she could think about was getting some rest, pouring herself a glass of wine, and curling up with a good book. But as she opened the door, something felt off. The house was too quiet, too still.
    
LaBlanche had been in many dangerous situations in her life, but she had never been quite so scared as she was in that moment. She crept through the house, slowly making her way to the study, where she knew her husband was meant to be. To her shock, she found him lying on the floor, motionless. 

For a moment, LaBlanche couldn't move. Her mind raced, trying to make sense of what was happening. Then she noticed something strange: there were no visible wounds on her husband's body. He had been murdered, then, she realized. With a trembling hand, she reached for the phone and dialed the police. 

When the officers arrived, they brought LaBlanche in for questioning. She gave her statement, but despite her best efforts, she could not provide them with any leads. For hours, the detectives interrogated her, trying to discover any hidden clues that would lead them to the killer. But LaBlanche had nothing to give them, and eventually they let her go with a warning. 

As she left the station, LaBlanche felt her stomach twist. She was no closer to finding her husband's murderer. She had failed him, and now it was up to her to unravel the mystery and bring justice to the killer.`,
  },
  {
    header: "Non-fiction article",
    text: "Write an essay about the benefits of replacing Coffee with Tea. There are three main benefits: it affects your sleep less, it’s easier on your heart, and there are tons of varieties and cultures related to tea to explore.",
    output: `Coffee and tea. Two beverages that have existed since antiquity, and yet, they remain as intertwined in our lives today as they were thousands of years ago. Countless cultures around the world have made these two drinks staples of their daily meal and beverage repertoires. But, for many of us, these two beverages represent a choice. And, in many cases, a difficult one. 

Coffee is often seen as the more popular and desirable of the two options, thanks to its energizing effects and bright, bitter taste. However, it also comes with its fair share of disadvantages. It can affect our sleep, disrupt our digestive system, and can even cause anxiety in some cases. 

On the other hand, tea, in all its amazing varieties, provides an excellent alternative. It can still satisfy our cravings for morning caffeine without the drawbacks of coffee. And, not only is it easier on our hearts, but there are also countless varieties and cultures related to tea to explore. 

From green and herbal teas to oolong and black teas, there’s an almost unlimited array of flavors and benefits to be found in tea. So, why not switch from coffee to tea and take advantage of the many benefits it provides? There’s no better time to make the switch than now.`,
  },
  {
    header: "Research",
    text: "Write a brief on how ninjas trained for battle in the 16th Century. Give details for what kinds of tools and weapons they used and what techniques were practiced.",
    note: "(Note: Make sure to fact check anything you find in Sudowrite)",
    output: `In the 16th century, ninjas trained for battle using a variety of weapons and tools. Among these were swords, daggers, spears, bows, and arrows. Ninjas also used the various tools of espionage, including smoke pellets and grappling hooks. 
    
The ninjas' training regimen was quite rigorous. They practiced various forms of martial arts, such as jujutsu and shuriken-jutsu (the art of throwing stars). Ninjas also developed their own specialized techniques, such as "mizu-ume," which involved using water and wind to deflect arrows.
    
In addition to weapon and physical training, ninjas also developed mental fortitude. They were trained in meditation techniques, the importance of secrecy and stealth, and the ability to remain calm and focused in stressful situations. Ninjas also practiced "shinobi-iri," or the art of invisibility. This involved learning how to blend into their surroundings and move silently and quickly.
    
As the centuries passed, ninjas continued to develop and refine their techniques, adapting to changing times and technologies. The training methods of the 16th century ninjas remain a testament to their remarkable skill and dedication.`,
  },
];
